module.exports = __webpack_public_path__ + "static/media/s13.a8023a03.png";